import { DatosParticipanteMiniLigasTO } from '@/types/minileagues';
import { cn, formatearNumero } from '@/utils/functions';

export const ItemPositions = ({
  data,
}: {
  data: DatosParticipanteMiniLigasTO;
  index?: number;
}) => {
  return (
    <div className="flex bg-white border-b-gdt-gray-6 border-b-[1px] pl-2 pr-4 lg:px-0 lg:py-6 text-xs font-semibold text-gdt-gray-3 py-4">
      <div className="w-12 lg:w-[50px]">
        <div
          className={cn(
            'rounded-full bg-gdt-status-green text-white w-9 h-9 lg:w-8 lg:h-8 font-bold text-lg flex justify-center items-center bg-gdt-status-green-light text-gdt-status-green'
          )}
        >
          <span>{data.pos || '-'}</span>
        </div>
      </div>
      <div className="flex-1 space-y-1">
        <p className="font-bold text-gdt-gray lg:text-sm">{`${data.part?.n} ${data.part?.a}`}</p>
        <p className="font-semibold text-3xs lg:text-xs text-gdt-gray-2">
          {data.ne}
        </p>
        <span className="lg:text-sm inline-block font-bold text-3xs bg-gdt-blue-light2 rounded-[3px] text-gdt-blue px-1">
          {(data.pts === undefined ? '0' : data.pts) +
            (data.pts === 1 ? ' punto' : ' puntos')}
        </span>
      </div>
      <div className="flex flex-1 justify-between items-center font-medium lg:text-sm">
        <p className="w-6 lg:w-20 text-center">{data.pj}</p>
        <p className="w-6 lg:w-20 text-center">{data.pg}</p>
        <p className="w-6 lg:w-20 text-center">{data.pe}</p>
        <p className="w-6 lg:w-20 text-center">{data.pp}</p>
        <p className="flex-1 lg:max-w-none lg:w-16 max-w-10 font-bold text-right text-gdt-gray lg:text-gdt-gray-3">
          {formatearNumero(data.posGral)}
        </p>
      </div>
    </div>
  );
};
